<template>
    <div class="warp">
        <div class="echarts" ref="echarts"></div>
    </div>
</template>
<script>
import echarts from 'echarts'
export default {
    name: 'echartsLine',
    props: ['incomeDatas'],
    data() {
        return {
            todayData: [3, 2, 3, 4, 15, 6, 7, 18, 9, 10, 11, 12, 13],
            yesterdayData: [13, 12, 11, 10, 9, 18, 7, 6, 25, 4, 3, 2, 11],
            xdata: []
        }
    },
    watch: {
        incomeDatas(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                this.initChart(this.incomeDatas)
            })
        }
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    mounted() {},
    methods: {
        initChart(datas) {
            this.todayData = datas.todayydata
            this.yesterdayData = datas.yesterdayydata
            this.xdata = datas.xdata
            this.chart = echarts.init(this.$refs.echarts)
            this.chart.setOption(this.getOption())
        },
        getOption: function() {
            // var _self = this
            return {
                color: ['#409EFF', '#67C23A'],
                tooltip: {
                    trigger: 'axis'
                    // formatter: function (value) {
                    //     // console.log(value)
                    //     if (value.length === 2) {
                    //         return `时间：0:00~${value[0].name}<br>${value[0].marker} 今日收入：${_self.todayData[value[0].dataIndex]}<br>${value[1].marker} 昨日收入：${_self.yesterdayData[value[1].dataIndex]}`
                    //     } else {
                    //         if (value[0].componentIndex === 0) {
                    //             return `时间：${value[0].name}<br>${value[0].marker} 今日收入：${_self.todayData[value[0].dataIndex]}`
                    //         } else {
                    //             return `时间：${value[0].name}<br>${value[0].marker} 昨日收入：${_self.yesterdayData[value[0].dataIndex]}`
                    //         }
                    //     }
                    // }
                },
                legend: {
                    data: ['今日收入', '昨日收入'],
                    icon: 'circle',
                    itemWidth: 10, // 设置宽度
                    itemHeight: 10 // 设置高度
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            show: false
                        }
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    axisLabel: {
                        color: '#545454' // 刻度线标签颜色
                    },
                    // data: ['0:00', '2:00', '4:00', '6:00', '8:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00', '22:00', '24:00']
                    data: this.xdata
                },
                yAxis: {
                    type: 'value',
                    name: '',
                    // nameTextStyle: {
                    //     color: 'red'
                    // },
                    axisLabel: {
                        color: '#545454' // 刻度线标签颜色
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: ['#f2f2f2'],
                            type: 'dashed'
                        }
                    }
                },
                series: [
                    {
                        name: '今日收入',
                        type: 'line',
                        // symbol: 'circle',
                        data: this.todayData
                    },
                    {
                        name: '昨日收入',
                        type: 'line',
                        // symbol: 'circle',
                        data: this.yesterdayData
                    }
                ]
            }
        }
    },
    computed: {}
}
</script>
<style scoped>
.warp {
    width: 100%;
    height: 100%;
}
.echarts {
    width: 100%;
    height: 100%;
}
</style>